export const MFA_CHALLENGE_VIEW = "mfa_challenge";

const AUTH_PATH_PREFIX = "/auth";

export const buildMfaChallengePath = (deeplink?: string | null): string => {
  const params = new URLSearchParams({ view: MFA_CHALLENGE_VIEW });
  // A deeplink back to the auth surface would bounce the user in a loop.
  if (deeplink && !deeplink.startsWith(AUTH_PATH_PREFIX)) {
    params.set("deeplink", deeplink);
  }
  return `${AUTH_PATH_PREFIX}?${params.toString()}`;
};
